import { z } from 'zod/v4';

export const BulkUpdateReporterUserSchema = z.object({
  userId: z.string().min(1),
  companyId: z.string().min(1),
});

export const BulkUpdateReporterRequestSchema = z
  .object({
    actionIds: z.array(z.string().min(1)).min(1),
    add: z.array(BulkUpdateReporterUserSchema).default([]),
    remove: z.array(BulkUpdateReporterUserSchema).default([]),
  })
  .refine(body => body.add.length + body.remove.length > 0, {
    message: 'Must provide at least one reporter to add or remove',
  });

export type BulkUpdateReporterRequest = z.infer<
  typeof BulkUpdateReporterRequestSchema
>;

export const BulkUpdateReporterResponseSchema = z.object({
  updatedCount: z.number(),
  message: z.string(),
});

export type BulkUpdateReporterResponse = z.infer<
  typeof BulkUpdateReporterResponseSchema
>;
